import script from "./PlatformAnnouncements.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformAnnouncements.vue?vue&type=script&setup=true&lang=js"

import "./PlatformAnnouncements.vue?vue&type=style&index=0&id=67c250f2&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enterpriseprodex/sxpf-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c250f2"]])

export default __exports__